module.exports = "<app-nav-tab></app-nav-tab>\r\n<router-outlet #o=\"outlet\"></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/journey.component.html
// module id = ./src/app/features/journey.component.html
// module chunks = main